import { useEffect, useState } from "react";
import { useWindowSize } from "./useWindowSize";

export function useModalWidthClass(): string {
  const [modalWidthClass, setModalWidthClass] = useState<string>("");
  const { width } = useWindowSize();

  const widthClassName =
    width < 1100
      ? "modal-60w"
      : width < 1300
      ? "modal-50w"
      : width < 1700
      ? "modal-40w"
      : "modal-30w";

  useEffect(() => {
    setModalWidthClass(widthClassName);
  }, [widthClassName]);

  return modalWidthClass;
}
